import React from 'react';
import "./Styles/Calculators.css";
import "./Styles/UserWelcome.css";
import NavBar from '../NavBar';
import CalculatorHeartAge from './Components/CalculatorPages/CalculatorHeartAge';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function CalculatorHeartAgeRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileHeartAgeRoutePage">
                    <div className="UserProfileHeartAgeRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="CalculatorHeartAgeRouteBlock">
                        <CalculatorHeartAge/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default CalculatorHeartAgeRoute;